import { UserRoles } from '../../api/queries.ts';

export class HRRolesUtils {
  public static isHRUser(userRoles: Array<UserRoles>): boolean {
    const mustHaveRole: UserRoles = UserRoles.HR_ADMIN;
    return userRoles.includes(mustHaveRole);
  }
}
